import { render, staticRenderFns } from "./curriculumSystem.vue?vue&type=template&id=bfad7f72&scoped=true&"
import script from "./curriculumSystem.vue?vue&type=script&lang=js&"
export * from "./curriculumSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfad7f72",
  null
  
)

export default component.exports